"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMultiplayerState = useMultiplayerState;
var _react = require("react");
var _reactSdk = require("@100mslive/react-sdk");
var _PusherCommunicationProvider = require("./PusherCommunicationProvider");
var _useWhiteboardMetadata = require("./useWhiteboardMetadata");
var _WhiteboardEvents = require("./WhiteboardEvents");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useWhiteboardState = function useWhiteboardState() {
  var _useWhiteboardMetadat = (0, _useWhiteboardMetadata.useWhiteboardMetadata)(),
    amIWhiteboardOwner = _useWhiteboardMetadat.amIWhiteboardOwner;
  var shouldRequestState = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectDidIJoinWithin)(850));
  return {
    shouldRequestState: shouldRequestState,
    amIWhiteboardOwner: amIWhiteboardOwner
  };
};

/**
 * Ref: https://github.com/tldraw/tldraw/blob/main/apps/www/hooks/useMultiplayerState.ts
 */
function useMultiplayerState(roomId) {
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    app = _useState2[0],
    setApp = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isReady = _useState4[0],
    setIsReady = _useState4[1];
  var _useWhiteboardState = useWhiteboardState(),
    amIWhiteboardOwner = _useWhiteboardState.amIWhiteboardOwner,
    shouldRequestState = _useWhiteboardState.shouldRequestState;

  /**
   * Stores current state(shapes, bindings, [assets]) of the whiteboard
   */
  var rLiveShapes = (0, _react.useRef)(new Map());
  var rLiveBindings = (0, _react.useRef)(new Map());
  var getCurrentState = (0, _react.useCallback)(function () {
    return {
      shapes: rLiveShapes.current ? Object.fromEntries(rLiveShapes.current) : {},
      bindings: rLiveBindings.current ? Object.fromEntries(rLiveBindings.current) : {}
    };
  }, []);
  var sendCurrentState = (0, _react.useCallback)(function () {
    if (amIWhiteboardOwner && isReady) {
      _PusherCommunicationProvider.provider.broadcastEvent(_WhiteboardEvents.WhiteboardEvents.CURRENT_STATE, getCurrentState());
    }
  }, [amIWhiteboardOwner, isReady, getCurrentState]);
  var updateLocalState = (0, _react.useCallback)(function (_ref) {
    var shapes = _ref.shapes,
      bindings = _ref.bindings,
      _ref$merge = _ref.merge,
      merge = _ref$merge === void 0 ? true : _ref$merge;
    if (!(shapes && bindings)) return;
    if (merge) {
      var lShapes = rLiveShapes.current;
      var lBindings = rLiveBindings.current;
      if (!(lShapes && lBindings)) return;
      Object.entries(shapes).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          id = _ref3[0],
          shape = _ref3[1];
        if (!shape) {
          lShapes["delete"](id);
        } else {
          lShapes.set(shape.id, shape);
        }
      });
      Object.entries(bindings).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          id = _ref5[0],
          binding = _ref5[1];
        if (!binding) {
          lBindings["delete"](id);
        } else {
          lBindings.set(binding.id, binding);
        }
      });
    } else {
      rLiveShapes.current = new Map(Object.entries(shapes));
      rLiveBindings.current = new Map(Object.entries(bindings));
    }
  }, []);
  var applyStateToBoard = (0, _react.useCallback)(function (state) {
    app === null || app === void 0 ? void 0 : app.replacePageContent(state.shapes, state.bindings, {} // Object.fromEntries(lAssets.entries())
    );
  }, [app]);
  var handleChanges = (0, _react.useCallback)(function (state) {
    if (!state) {
      return;
    }
    var shapes = state.shapes,
      bindings = state.bindings,
      eventName = state.eventName;
    updateLocalState({
      shapes: shapes,
      bindings: bindings,
      merge: eventName === _WhiteboardEvents.WhiteboardEvents.STATE_CHANGE
    });
    applyStateToBoard(getCurrentState());
  }, [applyStateToBoard, getCurrentState, updateLocalState]);
  var setupInitialState = (0, _react.useCallback)(function () {
    if (!isReady) {
      return;
    }
    if (amIWhiteboardOwner) {
      // On board open, update the document with initial/stored content
      handleChanges(_PusherCommunicationProvider.provider.getStoredEvent(_WhiteboardEvents.WhiteboardEvents.CURRENT_STATE));
      // Send current state to other peers in the room currently
      sendCurrentState();
    } else if (shouldRequestState) {
      /**
       * Newly joined peers request the owner for current state
       * and update their boards when they receive it
       */
      _PusherCommunicationProvider.provider.broadcastEvent(_WhiteboardEvents.WhiteboardEvents.REQUEST_STATE);
    }
  }, [isReady, amIWhiteboardOwner, shouldRequestState, handleChanges, sendCurrentState]);

  // Callbacks --------------
  // Put the state into the window, for debugging.
  var onMount = (0, _react.useCallback)(function (app) {
    app.loadRoom(roomId);
    app.pause(); // Turn off the app's own undo / redo stack
    // window.app = app;
    setApp(app);
  }, [roomId]);

  // Update the live shapes when the app's shapes change.
  var onChangePage = (0, _react.useCallback)(function (_app, shapes, bindings, _assets) {
    updateLocalState({
      shapes: shapes,
      bindings: bindings
    });
    _PusherCommunicationProvider.provider.broadcastEvent(_WhiteboardEvents.WhiteboardEvents.STATE_CHANGE, {
      shapes: shapes,
      bindings: bindings
    });

    /**
     * Tldraw thinks that the next update passed to replacePageContent after onChangePage is the own update triggered by onChangePage
     * and the replacePageContent doesn't have any effect if it is a valid update from remote.
     *
     * To overcome this replacePageContent locally onChangePage(not costly - returns from first line).
     *
     * Refer: https://github.com/tldraw/tldraw/blob/main/packages/tldraw/src/state/TldrawApp.ts#L684
     */
    applyStateToBoard(getCurrentState());
  }, [updateLocalState, applyStateToBoard, getCurrentState]);

  // Handle presence updates when the user's pointer / selection changes
  // const onChangePresence = useCallback((app, user) => {
  //   updateMyPresence({ id: app.room?.userId, user });
  // }, [][updateMyPresence]);

  // Subscriptions and initial setup
  (0, _react.useEffect)(function () {
    if (!app) return;
    var unsubs = [];
    var stillAlive = true;

    // Setup the document's storage and subscriptions
    function setupDocument() {
      // Subscribe to changes
      if (stillAlive) {
        unsubs.push(_PusherCommunicationProvider.provider.subscribe(_WhiteboardEvents.WhiteboardEvents.STATE_CHANGE, handleChanges));
        unsubs.push(_PusherCommunicationProvider.provider.subscribe(_WhiteboardEvents.WhiteboardEvents.CURRENT_STATE, handleChanges));

        // On request state(peer join), send whole current state to update the new peer's whiteboard
        unsubs.push(_PusherCommunicationProvider.provider.subscribe(_WhiteboardEvents.WhiteboardEvents.REQUEST_STATE, sendCurrentState));
        setIsReady(true);
      }
    }
    _PusherCommunicationProvider.provider.init(roomId);
    setupDocument();
    setupInitialState();
    return function () {
      stillAlive = false;
      unsubs.forEach(function (unsub) {
        return unsub();
      });
    };
  }, [app, roomId, setupInitialState, sendCurrentState, handleChanges]);
  (0, _react.useEffect)(function () {
    // Store last state on closing whitboard so that when the board is reopened the state could be fetched and reapplied
    var handleUnmount = function handleUnmount() {
      if (isReady && !shouldRequestState) {
        console.log("Whiteboard unmount storing", getCurrentState());
        _PusherCommunicationProvider.provider.storeEvent(_WhiteboardEvents.WhiteboardEvents.CURRENT_STATE, getCurrentState());
      }
    };
    return handleUnmount;
  }, [isReady, shouldRequestState, getCurrentState]);
  return {
    onMount: onMount,
    onChangePage: onChangePage
  };
}